 
import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import Background from '@/components/common/Background';
import SubtleBadge from '@/components/common/SubtleBadge';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountUp from 'react-countup';
import { FaArrowTrendUp,FaArrowTrendDown } from "react-icons/fa6";

const StatisticsCard = ({ stat, ...rest }) => {
  const {
    title,
    value,
    decimal,
    suffix,
    prefix,
    valueClassName,
    linkText,
    link,
    badgeText,
    badgeBg,
    image,
    className
  } = stat;
  return (
    <Card className={classNames(className, 'overflow-hidden')} {...rest}>
      <Background image={image} className="bg-card" />
      <Card.Body className="position-relative">
        <h6>
          {title}
          {badgeText && (
            <SubtleBadge bg={badgeBg} pill className="ms-2">
              {badgeText}
            </SubtleBadge>
          )}
        </h6>
        <div
          className={classNames(
            valueClassName,
            'display-4 fs-5 mt-3 fw-normal font-sans-serif'
          )}
        >
          <CountUp
            start={0}
            end={value}
            duration={2.75}
            suffix={suffix}
            prefix={''}
            separator=","
            decimals={decimal ? 2 : 0}
            decimal="."
          />
          <span className='float-end'>
          {
            prefix=="up"?<FaArrowTrendUp className="mr-2 fs-4 mt-auto"/>:prefix==="down"?<FaArrowTrendDown className="fs-4 mt-auto"/>:''
          }
          </span>
          
        </div>
        {linkText && (
          <Link to={link} className="fw-semibold fs-10 text-nowrap">
            {linkText}
            <FontAwesomeIcon
              icon="angle-right"
              className="ms-1"
              transform="down-1"
            />
          </Link>
        )}
      </Card.Body>
    </Card>
  );
};

export default StatisticsCard;
